import { useEffect } from "react"
import MainLayout from "../Layout"
import { FORESYTS_LOGIN_URL } from "../common/constants"

const ProtectedRouteAuth = ({ isLoggedIn }) => {
  const isLocal = process.env.NODE_ENV === "development"

  useEffect(() => {
    // Login.js already skips this same redirect in local dev (see its own
    // isLocal check) so a missing/expired token doesn't strand you on the
    // real foresyts.ai production site with no way back to localhost short
    // of hand-crafting a ?token= URL. This mirrored that same redirect
    // without the escape hatch, so a bad/missing token during local
    // testing bounced out to production every time.
    if (!isLoggedIn && !isLocal) {
      window.location.replace(FORESYTS_LOGIN_URL)
    }
  }, [isLoggedIn, isLocal])

  if (isLoggedIn) {
    return <MainLayout />
  }

  return isLocal ? (
    <div style={{ padding: 40, fontFamily: "sans-serif" }}>
      <h3>Not logged in (local dev)</h3>
      <p>
        No valid token found. Append <code>?token=&lt;a real JWT&gt;</code>{" "}
        to the URL, or set <code>LOCAL_DEV_TOKEN</code> in{" "}
        <code>src/App.js</code>.
      </p>
    </div>
  ) : null
}

export default ProtectedRouteAuth
